<!-- =========================================================================================
	File Name: App.vue
	Description: Main vue file - APP
========================================================================================== -->


<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  props: {
    organization_id: {
      type: Number,
      required: true,
    }
  },
  data() {
    return {}
  },
  // created: function () {
  //     this.$http.interceptors.response.use(undefined, function (err) {
  //         return new Promise(function (resolve, reject) {
  //             if (err.status === 401 && err.config && !err.config.__isRetryRequest) {
  //                 this.$store.dispatch(logout)
  //             }
  //             throw err;
  //         });
  //     });
  // },
  mounted() {
    let suffix = '';
    if(this.organization_id !== 1){
      suffix = '_' + this.organization_id;
    }

    this.$store.state.basicOrganizationData.logo = '/images/logos/logo' + suffix + '.png';
    this.$store.state.basicOrganizationData.logo_b = '/images/logos/logo_b' + suffix + '.png';
    this.$store.state.basicOrganizationData.logo_s = '/images/logos/logo_s' + suffix + '.png';
    this.$store.state.basicOrganizationData.logo_big = '/images/logos/logo_big' + suffix + '.png';
    this.$store.state.basicOrganizationData.logo_big_b = '/images/logos/logo_big_b' + suffix + '.png';
    this.$store.state.basicOrganizationData.logo_big_s = '/images/logos/logo_big_s' + suffix + '.png';

    document.body.classList.add('theme-semi-dark');
  },
}
</script>
